import { api } from '../../../services/api';
import { editTarget, hasChanges, recordingPatch, type RecordingDraft, type RecordingEditable } from './recordingEdit';

/**
 * CORE-1526 (п. 1) — отправка правки записи, общая для всех точек входа.
 *
 * Правка уходит в ту сущность, где живёт запись: у комнаты обновление
 * частичное и обложка ссылкой, у эфира — форма и обложка файлом. До этого
 * выбор ручки лежал в архиве, и вторая точка входа (страница записи) либо
 * повторила бы его, либо разошлась бы с ним при первой же правке.
 *
 * Возвращает `false`, если менять было нечего — форму тогда просто закрывают,
 * без запроса и без «Готово».
 */
export async function saveRecordingEdit(item: RecordingEditable, draft: RecordingDraft): Promise<boolean> {
    const patch = recordingPatch(item, draft);
    if (!hasChanges(patch)) return false;

    if (editTarget(item) === 'room') {
        await api.updateArchive(item.liveId, {
            title: patch.title,
            description: patch.description,
            coverImageUrl: patch.coverImageUrl,
        });
    } else {
        await api.updateLive(item.liveId, {
            title: patch.title,
            description: patch.description,
            coverImage: patch.coverFile,
        });
    }
    return true;
}
